let host = 'http://60.191.50.190:7013/api';
// let host = 'http://192.168.1.97:8030';


if (location.host.indexOf('local') !== -1) {
	host ='http://121.41.89.156:8088/api';
} else if (location.host.indexOf('60.191') !== -1) {
	host = 'http://60.191.50.190:7013/api';
} else if (location.host.indexOf('192.168') !== -1) {
	host ='http://121.41.89.156:8088/api';
} else if (location.host.indexOf('121.41') !== -1) {
	host = 'http://121.41.89.156:8088/api';
}
 host = 'https://jd.csyw.org.cn/bridge'
//host = 'http://test-bridge-api.51wephone.cn'
// host = 'http://192.168.1.148:8030/bridge'
let config = {
	'host': host,
}
export default config